import api from './api';

export const getShiftSchedules = (params) => api.get('/v1/shift-schedules', { params });
export const getShiftSchedule = (id) => api.get(`/v1/shift-schedules/${id}`);
export const createShiftSchedule = (data) => api.post('/v1/shift-schedules', data);
export const updateShiftSchedule = (id, data) => api.put(`/v1/shift-schedules/${id}`, data);
export const deleteShiftSchedule = (id) => api.delete(`/v1/shift-schedules/${id}`);
export const batchDeleteShiftSchedules = (ids) => api.post('/v1/shift-schedules/batch-delete', ids);
export const getShiftScheduleGrid = (params) => api.get('/v1/shift-schedules/grid', { params });
export const generateShiftSchedules = (data) => api.post('/v1/shift-schedules/generate', data);
export const getShiftScheduleGenerateScope = () => api.get('/v1/shift-schedules/generate-scope');
export const publishShiftSchedules = (data) => api.post('/v1/shift-schedules/publish', data);
export const bulkUpdateShiftSchedules = (data) => api.put('/v1/shift-schedules/bulk-update', data);
export const clearShiftSchedules = (data) => api.post('/v1/shift-schedules/clear', data);
export const copyWeekShiftSchedules = (data) => api.post('/v1/shift-schedules/copy-week', data);
export const getMySchedule = (params) => api.get('/v1/my-schedule', { params });
export const getShiftScheduleCompliance = (params) => api.get('/v1/shift-schedules/compliance', { params });
export const getShiftComplianceSettings = () => api.get('/v1/shift-schedules/compliance-settings');
export const updateShiftComplianceSettings = (data) => api.put('/v1/shift-schedules/compliance-settings', data);
